import LocalStorage from './LocalStorage'
import AuthService from './AuthService'

class ActivityTimeout {
  constructor () {
    this.timeout = null
    this.timeoutDuration = 60 * 60 * 1000 // 1 ora in millisecondi
    this.events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click']
    this.isInitialized = false
    this.logoutCallback = null
    this.publicPages = ['/login', '/firstlogin', '/firstotp', '/resetpassword', '/']
  }

  // Inizializza il sistema di timeout
  init (logoutCallback) {
    if (this.isInitialized) return

    this.logoutCallback = logoutCallback
    this.isInitialized = true

    // Avvia il timeout iniziale
    this.resetTimeout()

    // Aggiungi listener per tutti gli eventi di attività
    this.events.forEach(event => {
      document.addEventListener(event, this.resetTimeout.bind(this), true)
    })
  }

  // Verifica se siamo in una pagina pubblica
  isOnPublicPage () {
    const currentPath = window.location.pathname
    return this.publicPages.includes(currentPath)
  }

  // Resetta il timeout ogni volta che c'è attività
  resetTimeout () {
    // Cancella il timeout esistente
    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    // Verifica se siamo in una pagina pubblica
    if (this.isOnPublicPage()) {
      return
    }

    // Verifica se l'utente è ancora loggato
    const user = LocalStorage.get('user')
    if (!user) {
      return
    }

    // Imposta un nuovo timeout
    this.timeout = setTimeout(() => {
      this.performLogout()
    }, this.timeoutDuration)
  }

  // Esegue il logout automatico
  async performLogout () {
    // Esegue il callback di logout se fornito
    if (this.logoutCallback) {
      this.logoutCallback()
    }

    // Usa il servizio centralizzato per il logout automatico
    await AuthService.autoLogout()
  }

  // Pulisce tutti i listener e timeout
  cleanup () {
    if (this.timeout) {
      clearTimeout(this.timeout)
      this.timeout = null
    }

    this.events.forEach(event => {
      document.removeEventListener(event, this.resetTimeout.bind(this), true)
    })

    this.isInitialized = false
    this.logoutCallback = null
  }

  // Metodo per fermare temporaneamente il timeout (es. durante modali critici)
  pause () {
    if (this.timeout) {
      clearTimeout(this.timeout)
      this.timeout = null
    }
  }

  // Metodo per riattivare il timeout
  resume () {
    this.resetTimeout()
  }

  // Imposta una durata personalizzata (in millisecondi)
  setTimeoutDuration (duration) {
    this.timeoutDuration = duration
    this.resetTimeout() // Applica immediatamente la nuova durata
  }
}

// Esporta un'istanza singleton
const activityTimeoutInstance = new ActivityTimeout()
export default activityTimeoutInstance
